require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-launch-sells-out-twice-over-a-single-weekend.json") })
        }
      }, "path---news-yarrabend-launch-sells-out-twice-over-a-single-weekend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-launch-sells-out-twice-over-a-single-weekend!./.cache/json/news-yarrabend-launch-sells-out-twice-over-a-single-weekend.json
// module id = 871
// module chunks = 231608221292675